module.exports = __webpack_public_path__ + "static/img/icon_carType03.845e05b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_carType03.jpg
// module id = MWMK
// module chunks = 1